module.exports = __webpack_public_path__ + "efd801d8065724d371491b272800332d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/minus_decrement_enabled.svg
// module id = QnHY
// module chunks = 5